import { render, staticRenderFns } from "./VReaderMode.vue?vue&type=template&id=f4a44e48&"
import script from "./VReaderMode.vue?vue&type=script&lang=js&"
export * from "./VReaderMode.vue?vue&type=script&lang=js&"
import style0 from "./VReaderMode.vue?vue&type=style&index=0&id=f4a44e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports